import React from "react";
import { Outlet } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import AuthHeader from "../components/AuthHeader";
import { addS3Url } from "../utils/modules";

const AuthLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="d-flex flex-grow-1 flex-column bg-white">
      <div className="w-100 h-25 d-flex justify-content-center flex-wrap  align-content-end  position-relative pt-4">
        {(location.state === "coursesVideo" ||
          location.pathname.includes("/allBots") ||
          location.pathname.includes("/courses/")) && (
          <img
            src={addS3Url("/courses/arrow-left.svg")}
            style={{ position: "absolute", left: "4%", zIndex: 10 }}
            alt=""
            onClick={() => {
              navigate(-1);
            }}
          />
        )}
        {location.pathname.includes("/courses/") ||
        location.pathname.includes("/ai") ? (
          <p className="m-0 p-0 main-header">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="122.58"
              height="21.42"
              viewBox="0 0 122.58 21.42"
            >
              <path
                id="Logo"
                d="M-48.165-16.38h-7.95v4.05h7.8v4.62h-7.8V0h-4.8V-21h12.75Zm7.2,4.05a3.687,3.687,0,0,1,1.695-2.205,5.35,5.35,0,0,1,2.805-.765v5.1a4.508,4.508,0,0,0-3.075.555A3.033,3.033,0,0,0-40.965-6.78V0h-4.5V-15h4.5ZM-30.8-5.7q.78,2.1,3.6,2.1a3.722,3.722,0,0,0,2.88-1.14l3.6,2.07A7.539,7.539,0,0,1-27.255.42,8.2,8.2,0,0,1-33.3-1.83,7.66,7.66,0,0,1-35.565-7.5a7.728,7.728,0,0,1,2.235-5.655,7.722,7.722,0,0,1,5.745-2.265,7.236,7.236,0,0,1,5.445,2.265A7.842,7.842,0,0,1-19.965-7.5a8.582,8.582,0,0,1-.18,1.8Zm-.09-3.36h6.45a2.988,2.988,0,0,0-3.18-2.37A3.044,3.044,0,0,0-30.885-9.06Zm17.34,3.36q.78,2.1,3.6,2.1a3.722,3.722,0,0,0,2.88-1.14l3.6,2.07A7.539,7.539,0,0,1-10.005.42,8.2,8.2,0,0,1-16.05-1.83,7.66,7.66,0,0,1-18.315-7.5a7.728,7.728,0,0,1,2.235-5.655,7.722,7.722,0,0,1,5.745-2.265A7.236,7.236,0,0,1-4.89-13.155,7.842,7.842,0,0,1-2.715-7.5,8.582,8.582,0,0,1-2.9-5.7Zm-.09-3.36h6.45a2.988,2.988,0,0,0-3.18-2.37A3.044,3.044,0,0,0-13.635-9.06ZM4.785-4.62h7.5V0H-.015V-21h4.8ZM24.975-15h4.5V0h-4.5V-1.41A5.605,5.605,0,0,1,20.5.42a6.627,6.627,0,0,1-5.07-2.3,8.027,8.027,0,0,1-2.1-5.625,8.027,8.027,0,0,1,2.1-5.625A6.627,6.627,0,0,1,20.5-15.42a5.605,5.605,0,0,1,4.47,1.83ZM18.825-4.83a3.49,3.49,0,0,0,2.58.99,3.49,3.49,0,0,0,2.58-.99,3.608,3.608,0,0,0,.99-2.67,3.608,3.608,0,0,0-.99-2.67,3.49,3.49,0,0,0-2.58-.99,3.49,3.49,0,0,0-2.58.99,3.608,3.608,0,0,0-.99,2.67A3.608,3.608,0,0,0,18.825-4.83Zm22.74-10.59a5.359,5.359,0,0,1,4,1.65,6.263,6.263,0,0,1,1.605,4.56V0h-4.5V-8.55a2.675,2.675,0,0,0-.735-2.025,2.6,2.6,0,0,0-1.875-.7,2.7,2.7,0,0,0-2.04.78,3.211,3.211,0,0,0-.75,2.31V0h-4.5V-15h4.5v1.41A4.976,4.976,0,0,1,41.565-15.42ZM55.7-4.2h5.97V0h-12V-3l5.67-7.8h-5.37V-15h11.4v3Z"
                transform="translate(60.915 21)"
                fill="#14a800"
              />
            </svg>
          </p>
        ) : (
          <img
            alt=""
            src={addS3Url("/courses/icon.png")}
            style={{ width: "100px", height: "100%", borderRadius: "10px" }}
          />
        )}
        <div style={{ position: "absolute", right: "4%" }}>
          <AuthHeader />
        </div>
      </div>
      <div className="d-flex flex-column flex-grow-1 justify-content-start px-3">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
